import styled from "styled-components";
import theme from '../../theme';

const Price = styled.span`
    font-size: ${props => props.fontSize ? props.fontSize : theme.fontSize.h1}px;
    font-weight: bold;
    margin-left: 4px;
`

export default Price